export default {
  es: {
    intro: {
      hashtag: "#Inergízate",
      postBtn: "VER MÁS",
      company: {
        title: "¿ERES EMPRESA?",
        btn: "VER MÁS",
      },
    },
    suministros: {
      title: "Suministros",
      finds: "Encuentra tu",
      fee: "tarifa",
      yourFee: "Tu tarifa",
      gas: "Gas",
      light: "Luz",
      price: "a precio de coste +",
      month: "mes",
      monthlyFee: "Cuota fija mensual",
      btnEnergize: "Quiero inergizarme ya",
      btnShowRates: "Ver Tarifas",
      offer: "Ofrecemos",
      offerDescription: "un suministro transparente y adaptado a tu consumo diario",
    },
    instalaciones: {
      title: "Instalaciones",
      facility: "Instalación",
      selfConsumption: "autoconsumo",
      aerotermia: "aerotermia",
      electricVehicle: "v.eléctrico",
      yourFacility: "Tu instalación",
      from: "desde",
      btnShowMore: "Ver más",
      vehicule: "coche",
      solar: "solar",
      clima: "clima",
    },
    asiSomos: {
      title1: "Así",
      title2: "somos",
      nationals: "nacionales",
      cheap: "baratos",
      close: "cercanos",
      price: {
        title: "Luz a precio de un helado",
        paragraph:
          "En Iner comparamos el precio de la luz y el gas con cosas cotidianas, como un helado, para que entiendas fácilmente lo que vas a pagar y compruebes si realmente somos tan baratos como decimos.",
      },
      nearYou: {
        title: "Tu energía de confianza, cerca de ti",
        paragraph:
          "No hace falta buscar lejos: somos una empresa de energía 100% española, con sede en Castilla-La Mancha, Madrid y Euskadi. Comprometidos con tu comunidad, ofrecemos energía cercana, eficiente y pensada para ti.",
      },
      contact: {
        title: "¡Llámanos y pregunta por tu agente de confianza!",
        paragraph:
          "En Iner, nos encanta la cercanía del tú a tú. Por eso, cuando nos llames, hablarás directamente con tu agente de confianza: Pilar, Luis, Mª Carmen, o cualquiera de nuestro equipo. ¡Nada de contestadores automáticos ni máquinas haciendo nuestro trabajo! Y, sobre todo, sin llamadas de spam, estés o no con Iner. Respetamos tu tranquilidad y solo contactamos contigo si tú quieres.",
      },
      btnKnows: "Que más ofrecemos",
      btnServices: "Inergízate ya",
    },
    dicenNosotros: {
      title1: "YA CONFÍAN",
      title2: "en nosotros",
    },
  },
  en: {},
};



// WEBPACK FOOTER //
// ./src/translations/home.js